import {drawCartoArrows} from './main/carto_arrow.js';
// import {drawTimelapseArrows} from './main/timelapse_arrows.js';

// import * as d3 from 'd3';
import { descending } from 'd3-array';
import { nest } from 'd3-collection';
import { timeParse, timeFormat } from 'd3-time-format';
import { format } from 'd3-format';
import { select } from 'd3-selection';
import { scaleTime, scaleLinear } from 'd3-scale';
import { line as d3line } from 'd3-shape';
import { area as d3area } from 'd3-shape';
import { axisBottom, axisLeft } from 'd3-axis';

import context from '../../data/text.json';
import ili from '../../process/processed/ILINet.json';
import icu from '../../process/processed/latestICUBeds.json';
import ctp from '../../process/processed/testing_data.json';
import timelapseData from '../../process/processed/timelapse.json';

// console.log(ctp)
// --------------- ASH LAND

var circleRadius = 3;
var failColor = "#ec4c4c";
var passColor = "#20c17c";
var darkGrayColor = "#999";

var todaysDate = getTodaysDate()
var parseDate = timeParse("%Y%m%d");
var parseDate2 = timeParse("%m/%d/%Y");
var formatDate = timeFormat("%b %-d");
var fmtComma = format(",")
var formatLongMonthDate = timeFormat("%B %-d");
var formatRegDate = timeFormat("%B %-d, %Y")
var margin = {top: 10, right: 0, bottom: 0, left: 3};

var iliRolled;
var icuRolled;

var dataMap;
var variableMap = {
	"icu": "pctICUBedsOccupied",
	"inpatient": "pctInpatientBedsOccupied",
	"ili": "%UNWEIGHTED ILI",
	"test": "mov_total",
	"positive": "mov_perc",
	"absolute": "mov_100k"
}

var slopeVariables = [
"mov_100k",
"mov_perc",
"mov_total"]

var xDomainMap = {
	"icu": [],
	"inpatient": [],
	"ili": [],
	"test": [],
	"positive": [],
	"absolute": []
}

var yDomainMap = {
	"icu": [0, 100],
	"inpatient": [0, 100],
	"ili": [0, 5],
	"test": [0, 300],
	"positive": [0, 30],
	"absolute": [0, 100]
}

var barLineMap = {
	"test": [0, 300],
	"icu": [0, 100]
}

var yLabelMap = {
	"icu": yDomainMap["icu"][1] + "%",
	"inpatient": yDomainMap["inpatient"][1] + "%",
	"ili": yDomainMap["ili"][1] + "%",
	"test": yDomainMap["test"][1] + " tests",
	"positive": yDomainMap["positive"][1] + "%",
	"absolute": yDomainMap["absolute"][1] + " cases per 100k"
}

var thresholdMap = {
	"icu": 30,
	"test": 100
}

var flat = {
	"positive": 0.5,
	"absolute": 0.25,
	"ili": 0.25
}

var quartileMap = {
	"low": `${context.ratingSub1} ${context.ratingSub4}`,
	"medium": `${context.ratingSub2}  ${context.ratingSub4}`,
	"high": `${context.ratingSub3}  ${context.ratingSub4}`
}


// console.log(ctp)
drawCartoArrows(timelapseData)
setupData()
setupTable()
setupSelectize()
$("#updateDate").text(`Updated ${formatRegDate(xDomainMap["test"][1])}`)
// $("#updateDate").text(`Updated ${formatRegDate(new Date())}`)

function setupData() {

	icu.forEach(function(d, i){
		var row = icu[i]
		// turn date field into an actual Date object
		row.date = new Date(row.date + " 0:00:00")
		if (row.pctICUBedsOccupied == 0) {
			row.pctICUBedsOccupied = NaN
		} else {
			row.pctICUBedsOccupied = 100 - +row.pctICUBedsOccupied
			row.pctICUBedsOccupied = Math.max(row.pctICUBedsOccupied, 0)
		}
	})

	ili.forEach(function(d, i) {
		var row = ili[i]
		row.WEEK = +row.WEEK
		row["%UNWEIGHTED ILI"] = +row["%UNWEIGHTED ILI"]
		row["date"] = getDateOfWeek(row.WEEK, +row.YEAR)
	})

	icu.sort((a, b) => descending(a.date, b.date))

	icuRolled = nest()
	.key(d => d.state)
	.object(icu);

	iliRolled = nest()
	.key(d => d.REGION)
	.object(ili);

	dataMap = {
		"icu": icuRolled,
		"ili": iliRolled
	}

}




//------------ SETUP TABLE


function setupTable() {
	ctp.forEach(function(stateData, index) {
		stateData.or_end = parseDate2(stateData.or_end)
		stateData.or_start = parseDate2(stateData.or_start)

		for (let i = 0; i < slopeVariables.length - 1; i++) {
			let variable = slopeVariables[i]
			stateData[variable].trend[0] = parseDate(stateData[variable].trend[0])
			stateData[variable].trend[2] = parseDate(stateData[variable].trend[2])
		}

		(stateData.values).forEach(function(d, index2) {
			d.date = parseDate(d.date)
		})
	})
	var ctpRolled_2 = nest()
	.key(d => { return d.state; })
	.object(ctp)

	let example = ctpRolled_2["CA"][0].values
	xDomainMap.test = [example[0].date, example[example.length - 1].date]
	xDomainMap.positive = xDomainMap.test
	xDomainMap.absolute = xDomainMap.test

	dataMap.test = ctpRolled_2;
	dataMap.positive = ctpRolled_2;
	dataMap.absolute = ctpRolled_2;

	let variables = ["absolute", "positive", "test", "icu", "ili"]


	variables.forEach(function(variable, index) {
		if (variable == "ili") {
			let filteredData = dataMap[variable]["California"]
			xDomainMap.ili = [filteredData[0].date, filteredData[filteredData.length - 1].date]
		}
		setupDefs(variable)
	})




	for (let [key, value] of Object.entries(ctpRolled_2)) {
		var stateRow = ctpRolled_2[key][0]
		var metricCorrectCount = 0

		variables.forEach(function(variable, index) {
			var data = dataMap[variable]
			var filteredData = (["test", "positive", "absolute"].includes(variable)) ? data[stateRow.state][0].values : data[stateRow.state_name];

			if (variable == "ili") {
				filteredData = data[stateRow.state_name].filter(d => {
					return d.YEAR == "2020" && d.WEEK > 15
				})
				xDomainMap.ili = [filteredData[0].date, filteredData[filteredData.length - 1].date]
			}

			let mostRecentRow = filteredData[filteredData.length - 1]

			let mostRecentVal = mostRecentRow[variableMap[variable]]

			if (isNaN(mostRecentVal) || (["positive"].includes(variable) && stateRow.state_name == "Puerto Rico")) {
				$(`#${variable}-${stateRow.state}`).html(`<div class="noData">No Data Available</div>`)
				$(`#${variable}-${stateRow.state}`).addClass("noDataChart")
			} else if (["positive", "test"].includes(variable) && ["MS","IA"].includes(stateRow.state)) {
				$(`#${variable}-${stateRow.state}`).html(`<div class="noData">Data Unreliable For This Time Period</div>`)
			} else if (["positive","absolute"].includes(variable) && [].includes(stateRow.state)) {
				$(`#${variable}-${stateRow.state}`).html(`<div class="noData">Data Unreliable For This Time Period</div>`)
			} else if (["ili"].includes(variable) && ["IA"].includes(stateRow.state)) {
				$(`#${variable}-${stateRow.state}`).html(`<div class="noData">Data Unreliable For This Time Period</div>`)
			} else if (["positive"].includes(variable) && ["WI","WY"].includes(stateRow.state)) {
				$(`#${variable}-${stateRow.state}`).html(`<div class="noData">Data Unreliable For This Time Period</div>`)
			// } else if (["icu"].includes(variable)) {
			// 	$(`#${variable}-${stateRow.state}`).html(`<div class="noData">Data Is No Longer Being Updated By HHS</div>`)
			} else {
				setupChart(variable, stateRow, filteredData, mostRecentRow, mostRecentVal)
				metricCorrectCount += setupGrade(variable, stateRow, filteredData, mostRecentRow, mostRecentVal)	
			}
		})

		setupReopen(stateRow, metricCorrectCount)
		setupNote(stateRow.state, stateRow.state_name)
	}
}

function setupDefs(variable) {
	var el = `#${variable}-CA`;
	var jEl = $(el);
	var w = jEl.width() - margin.left - margin.right;	
	w = Math.max(120, w)
	var h = jEl.height() - margin.top - margin.bottom;

	["open", "closed"].forEach(function(reopenedStatus, index){
		reopenedStatus = "open"
		let defG = select(`#${variable}-${reopenedStatus}`)
		

		if (["test", "icu"].includes(variable)) {
			var x = scaleLinear()
			.domain(yDomainMap[variable])
			.range([0, w]);

			let rectHeight = $(window).width() < 1000 ? 80 : 90;
			var startingPoint = [0, 0]
			let secondY = rectHeight + 12;
			let firstY = secondY + 11;
			let lineY = 0
			let lineY2 = rectHeight

			defG.append("text")
			.attr("class", "labelText")
			.attr("x", x(0))
			.attr("y", startingPoint[1])
			.attr("dy", secondY)
			.attr("text-anchor", "start")
			.text(barLineMap[variable][0])

			defG.append("text")
			.attr("class", "labelText")
			.attr("x", w)
			.attr("y", startingPoint[1])
			.attr("dy", secondY)
			.attr("text-anchor", "end")
			.text(barLineMap[variable][1])

			defG.append("text")
			.attr("class", "labelText")
			.attr("x", x(thresholdMap[variable]))
			.attr("y", startingPoint[1])
			.attr("dy", secondY)
			.attr("text-anchor", "middle")
			.text("Goal:")

			defG.append("text")
			.attr("class", "labelText")
			.attr("x", x(thresholdMap[variable]))
			.attr("y", startingPoint[1])
			.attr("dy", firstY)
			.attr("text-anchor", "middle")
			.text(`${thresholdMap[variable]}${variable == "icu" ? "%" : " tests"}`)

			defG.append("line")
			.attr("class", "thresholdLine")
			.attr("x1", x(thresholdMap[variable]))
			.attr("x2", x(thresholdMap[variable]))
			.attr("y1", startingPoint[1] + lineY)
			.attr("y2", startingPoint[1] + lineY2)
			.attr("stroke", reopenedStatus == "open" ? "#efefef" : "#222")


		} else {
			// Set the ranges
			var x = scaleTime()
			.domain(xDomainMap[variable])
			.range([0, w]);

			var y = scaleLinear()
			.domain(yDomainMap[variable])
			.range([$(window).width() < 1000 ? h + margin.top : h, 0]);

			let tickSize = 0;
			// Set up the x axis
			var xaxis = defG.append("g")
				.attr("transform", "translate(0," + h + ")")
				.attr("class", "x axis xaxis")
				.call(axisBottom(x)
					.tickValues(xDomainMap[variable])
					.tickSize(tickSize, tickSize)
					.tickFormat(formatDate)
					.tickPadding(5));

			// apply specific ids so as to style the x ticks individually
			xaxis.selectAll("text")
				.attr("class", function(d,i) {return "xaxis" + i})
				.attr("fill", reopenedStatus == "open" ? "#777" : "#aaa")
				.attr("font-family", "graphik")

			// Add the Y Axis
			var yaxis = defG.append("g")
			.attr("class", "y axis yaxis")
			.call(axisLeft(y)
				.tickValues(yDomainMap[variable])
				.ticks(1)
				.tickSizeInner(0)
				.tickSize(-w, tickSize));
			// apply specific ids so as to style the x ticks individually
			yaxis.selectAll(".tick text").attr("class", function(d,i) {return "tick-text" + i});
			yaxis.selectAll(".tick line").attr("class", function(d,i) {return "tick-line" + i});

			yaxis.selectAll(".tick-line0")
				.attr("stroke-width", 0)
				.attr("display", "none")

			yaxis.selectAll(".tick-text1").text("")
			yaxis.selectAll(".tick-text1").text(yLabelMap[variable])
			.attr("dx", 5)
			.attr("dy", 10)
			.attr("fill", reopenedStatus == "open" ? "#777" : "#aaa")
			.attr("font-family", "graphik")
		}
	})
}

function setupNote(stateAbbreviation, stateName){
	let reopenDoc = dataMap["test"][stateAbbreviation][0].doc
	let html = `Note: `
	let noteExists = false;
	let stateData = dataMap.absolute[stateAbbreviation][0]

	if (stateData.combine) {
		let entity = stateName
		if (noteExists) {
			entity = "The state"
		}
		html += `${entity} ${context.combiningTestsNote} `
		noteExists = true;
	}

	if (stateData.specimen) {
		let entity = stateName
		if (noteExists) {
			entity = "The state"
		}
		html += `${entity} ${context.reportingSpecimensNote} `
		noteExists = true;
	}

	if (reopenDoc != null) {
		let entity = stateName
		if (noteExists) {
			entity = "The state"
		}
		html += `${entity} ${context.reopeningDoc1} <a href="${reopenDoc}" target="_blank">${context.reopeningDoc2}</a> `
		noteExists = true;
	}

	let docNote = dataMap["test"][stateAbbreviation][0].note
	if (docNote != "") {
		if (noteExists) {
			html += " "
		}
		html += docNote
		noteExists = true;	
	}
	
	// hide the note if there is nothing extra to share
	if (!noteExists) {
		$(`#state-note-${stateAbbreviation}`).hide()
		select(`#state-note-${stateAbbreviation}`).style("display", "none")
	}

	$(`#state-note-${stateAbbreviation}`).html(html)
}

function setupGrade(variable, stateRow, filteredData, mostRecentRow, mostRecentVal) {
	var el = `#${variable}-grade-${stateRow.state}`;
	var jEl = $(el);
	var w = jEl.width() - margin.left - margin.right;	
	var h = jEl.height() - margin.top - margin.bottom;

	let goodOrBad;
	let gradeWord = "steady"

	if (["test", "icu"].includes(variable)) {
		goodOrBad = getGoodOrBad(variable, mostRecentVal)
		gradeWord = goodOrBad == "good" ? "meets goal" : "does not meet goal"
	} else if (variable == "ili") {
		let iliDataRow = dataMap[variable][stateRow.state_name][0]

		var x = scaleTime()
		.domain(xDomainMap[variable])
		.range([0, w]);

		var y = scaleLinear()
		.domain(yDomainMap[variable])
		.range([h, 0]);

		let val = iliDataRow.trend[3] - iliDataRow.trend[1]
		goodOrBad = getGoodOrBad(variable, val)
		if (goodOrBad == "flat") {
			gradeWord = "steady"
		} else {
			gradeWord = goodOrBad == "good" ? "decreasing" : "increasing"	
		}
	} else {
		var val = stateRow[variableMap[variable]].trend[3] - stateRow[variableMap[variable]].trend[1]
		goodOrBad = getGoodOrBad(variable, val)
		if (goodOrBad == "flat") {
			gradeWord = "steady"
		} else {
			gradeWord = goodOrBad == "good" ? "decreasing" : "increasing"	
		}
	}

	var svg = select(el)
	.append("svg")
	.append("g")
	.attr("transform","translate(" + margin.left + "," + margin.top + ")");

	let symbol = `<div class="flatColorSvg colorSvg"><svg class="flatColor">
		<use xlink:href="#flatMark"/>
		</svg></div>`
	if (goodOrBad == "good") {
		symbol = `<div class="passColorSvg colorSvg"><svg class="passColor">
			<use xlink:href="#checkMark"/>
			</svg></div>`
	} else if (goodOrBad == "bad") {
		symbol = `<div class="failColorSvg colorSvg"><svg class="failColor">
			<use xlink:href="#crossMark"/>
			</svg></div>`
	}
	
	// slope chart
	let html = ""
	html += `<div class="grade-word">${gradeWord}</div>`
	html += symbol
	select(el)
	.attr("class", `state-grade ${getColorClass(variable, mostRecentVal)}`)

	select(el).html(html)

	return (goodOrBad == "good") ? 1 : 0;
}

function setupBarGrade(svg, variable, mostRecentVal, w, h, margin, reopenedStatus) {
	reopenedStatus = "open"
	// Set the ranges
	var x = scaleLinear()
	.domain(yDomainMap[variable])
	.range([0, w]);

	svg.attr("overflow", "visible")

	let rectHeight = $(window).width() < 1000 ? 80 : 90;
	var startingPoint = [0, 0]
	let secondY = rectHeight + 12;
	let firstY = secondY + 11;
	let lineY = 0
	let lineY2 = rectHeight

	let rectWidth = x(mostRecentVal)
	let mostRecentValText = Math.round(mostRecentVal)
	if (mostRecentVal > barLineMap[variable][1]) {
		rectWidth = x(barLineMap[variable][1])
		mostRecentVal = barLineMap[variable][1]
		mostRecentValText = mostRecentVal + "+"
	}

	svg.append("rect")
	.attr("class", "barRect")
	.attr("x", 0)
	.attr("y", startingPoint[1])
	.attr("width", function(d) {
		return rectWidth > 0 ? rectWidth : 0
	})
	.attr("height", rectHeight)

	svg.append("use")
		.attr("xlink:href", `#${variable}-${reopenedStatus}`)







	let max = yDomainMap[variable][1]
	let threshold = (variable == "test") ? 2 : 3.3;
	if ((mostRecentVal > max * 4/ 5)) {
			// inside the rect
			svg.append("text")
			.attr("class", "endpointTextInside endpointText")
			.attr("x", x(mostRecentVal))
			.attr("y", startingPoint[1] - 1)
			.attr("dx", -6)
			.attr("dy", (lineY + lineY2) / 2 + 6)
			.attr("text-anchor", "end")
			.text(`${mostRecentValText}${variable == "icu" ? "%" : ""}`)
		} else {
			svg.append("text")
			.attr("class", "endpointTextBar endpointText")
			.attr("fill", "black")
			.attr("x", x(mostRecentVal))
			.attr("y", startingPoint[1] - 1)
			.attr("dx", 4)
			.attr("dy", (lineY + lineY2) / 2 + 6)
			.attr("text-anchor", "start")
			.text(`${mostRecentValText}${variable == "icu" ? "%" : ""}`)

		}
	}

function setupArrow(svg, stateRow, variable, filteredData, mostRecentVal, w, h, margin, x, y) {
	let reopenedStatus = dataMap["test"][stateRow.state][0].reopen
	reopenedStatus = "open"
	var slopeData;
	if (variable == "ili") {
		slopeData = calculateIliLinearRegression(filteredData, x, y)
		dataMap["ili"][stateRow.state_name][0].trend = slopeData
	} else {
		slopeData = filteredData[variableMap[variable]].trend
		slopeData[0] = slopeData[0]
		slopeData[2] = slopeData[2]
		slopeData[1] = slopeData[1]
		slopeData[3] = slopeData[3]
	}

	svg.append("line")
	.attr("class", "trendLine")
	.attr("x1", x(slopeData[0]))
	.attr("x2", x(slopeData[2]))
	.attr("y1", y(slopeData[1]))
	.attr("y2", y(slopeData[3]))
	.attr("marker-end", function(d) {
		return `url(#arrow-${reopenedStatus})`
	})
	.attr("marker-start", function(d) {
		return `url(#circle-${reopenedStatus})`
	})
}

function setupChart(variable, stateRow, filteredData, mostRecentRow, mostRecentVal) {
	var el = `#${variable}-${stateRow.state}`;

	var data = dataMap[variable]

	var jEl = $(el);
	var w = jEl.width() - margin.left - margin.right;	
	w = Math.max(120, w)
	var h = jEl.height() - margin.top - margin.bottom;

	var svg = select(el)
	.append("svg")
	.append("g")
	.attr("transform","translate(" + margin.left + "," + margin.top + ")");

	let reopenedStatus = dataMap["test"][stateRow.state][0].reopen
	reopenedStatus = "open"

	if (["test", "icu"].includes(variable)) {
		// bar chart 
		setupBarGrade(svg, variable, mostRecentVal, w, h, margin, reopenedStatus)
	} else {

		// Set the ranges
		var x = scaleTime()
		.domain(xDomainMap[variable])
		.range([0, w]);

		var y = scaleLinear()
		.domain(yDomainMap[variable])
		.range([h, 0]);

		svg.append("use")
			.attr("xlink:href", `#${variable}-${reopenedStatus}`)

		// Define the line
		var line = d3line()
		.defined(d => {
			return d[variableMap[variable]] != ""
		})
		.x(d => x(d.date))
		.y(d => y(d[variableMap[variable]]))

		var area = d3area()
		.defined(d => {
			return d[variableMap[variable]] != ""
		})
		.y0(y(0))
		.x(d => x(d.date))
		.y1(d => y(d[variableMap[variable]]))

		svg.selectAll(".dataLine")
		.data([filteredData])
		.enter()
		.append("path")
		.attr("stroke", darkGrayColor)
		.attr("class", "dataLine")
		.attr("d", d => line(d))

		// ADD SLOPE ARROW

		let arrowData = (variable == "ili") ? filteredData : stateRow;
		setupArrow(svg, stateRow, variable, arrowData, mostRecentVal, w, h, margin, x, y)

		// ADD ENDPOINT LABEL

		let endpointCoord = [x(mostRecentRow["date"]), y(mostRecentVal)]

		let rectW = 2;
		let rectH = 16;
		let charLength = 9;
		let dy = -10;
		let text = fmtComma(roundTwoSigFigs(mostRecentVal))
		text += (!["test", "absolute"].includes(variable) ? "%" : "");
		let calcRectW = rectW + (charLength * text.length)
		let dx = -text.length * 6;	

		svg.append("text")
		.attr("class", "endpointText")
		.attr("x", endpointCoord[0] + calcRectW / 2 + dx)
		.attr("y", endpointCoord[1])
		.attr("dy", dy)
		.attr("dx", -5)
		.attr("text-anchor", "middle")
		.text(text)

	}
}



function setupReopen(stateRow, metricCorrectCount) {
	let html = ""
	let daysDiff = 0
	if (stateRow.reopen == "open") {
		if (stateRow.or_end) {
			daysDiff = getDaysDiff(todaysDate, stateRow.or_end)
		}
		$(`#state-row-${stateRow.state}`).attr("class", "state-row openedRow")
		$(`#state-name-${stateRow.state}`).attr("class", "state-name")
		html += ` <span class="status"><strong>${context.noStayAtHome}</strong>`
	} else {
		daysDiff = getDaysDiff((stateRow.or_start), todaysDate)
		$(`#state-row-${stateRow.state}`).attr("class", "state-row openedRow")
		$(`#state-name-${stateRow.state}`).attr("class", "state-name")
		if (stateRow.state == "KY") {
			html += ` <span class="status"><strong>Healthy at home guidance</strong>`
		} else {
			html += ` <span class="status"><strong>${context.stayAtHome}</strong>`	
		}
	}
	if (stateRow["days_since"] != "NA") {
		// increment by 1 so that there are no 0 days
		// daysDiff += 1
		daysDiff = fmtComma(daysDiff)
		html += `<span class="subDefinition">for ${daysDiff} ${dayorDays(daysDiff)}</span></span>`	
	} 
	html += `</span>`
	html += `<span class="status"> <strong>${capitalizeFLetter(stateRow.quartile)}</strong> ${context.rating}`
	html += `<span class="subDefinition">${quartileMap[stateRow.quartile]}</span>`
	html += `</span>`
	$(`#status-${stateRow.state}`).html(html)
}

function dayorDays(num) {
	if (num == 0) return "days"
	return num > 1 ? "days" : "day"
}

function calculateIliLinearRegression(filteredData, x, y) {
	// get the x and y values for least squares
	var xSeries = filteredData.map(d => x(d.date));
	var ySeries = filteredData.map(d => y(d[variableMap["ili"]]));
	var ySeries1 = filteredData.map(d => (d[variableMap["ili"]]));
	
	var leastSquaresCoeff = leastSquares(xSeries, ySeries);
	var slope = leastSquaresCoeff[0];
	var intercept = leastSquaresCoeff[1];
	var rSquare = leastSquaresCoeff[2];

	// apply the reults of the least squares regression
	var x1 = xSeries[0];
	var y1 = intercept;
	var x2 = xSeries[xSeries.length - 1];
	var y2 = slope * x(xDomainMap["ili"][1]) + intercept;

	return [x.invert(x1),y.invert(y1),x.invert(x2),y.invert(y2), slope];
}


function getDateDifference(date1, date2) {
	// First we split the values to arrays date1[0] is the year, [1] the month and [2] the day
	date1 = date1.split('-');
	date2 = date2.split('-');

	// Now we convert the array to a Date object, which has several helpful methods
	date1 = new Date(date1[0], date1[1], date1[2]);
	date2 = new Date(date2[0], date2[1], date2[2]);

	// We use the getTime() method and get the unixtime (in milliseconds, but we want seconds, therefore we divide it through 1000)
	let date1_unixtime = parseInt(date1.getTime() / 1000);
	let date2_unixtime = parseInt(date2.getTime() / 1000);

	// This is the calculated difference in seconds
	var timeDifference = date2_unixtime - date1_unixtime;

	// in Hours
	var timeDifferenceInHours = timeDifference / 60 / 60;

	// and finaly, in days :)
	var timeDifferenceInDays = timeDifferenceInHours  / 20;

	return timeDifferenceInDays
}

// YYYY-MM-DD format
function getTodaysDate() {
	var today = new Date();
	today.setHours(0,0,0,0)
	return today
}

function getColor(variable, mostRecentVal) {
	if (variable == "test") {
		return (mostRecentVal > 152) ? passColor : failColor;
	} else if (variable == "positive") {
		return (mostRecentVal > 10) ? failColor: passColor;
	} else {
		return (mostRecentVal > 70) ? failColor : passColor;
	}
}

function getGoodOrBad(variable, val) {
	val = roundTwoSigFigs(val)
	let diff = Math.abs(val)
	if (variable == "test") {
		return (val >= thresholdMap[variable]) ? "good" : "bad";
	} else if (variable == "icu") {
		return (val >= thresholdMap[variable]) ? "good" : "bad";
	} else {
		if (diff < flat[variable]) return "flat"
		return (val >= 0) ? "bad" : "good";
	}
}

function getColorClass(variable, mostRecentVal) {
	if (variable == "test") {
		return (mostRecentVal > 152) ? "passColor" : "failColor";
	} else if (variable == "positive") {
		return (mostRecentVal > 10) ? "failColor": "passColor";
	} else {
		return (mostRecentVal > 70) ? "failColor" : "passColor";
	}
}

function getDateOfWeek(w, y) {
    var d = (1 + (w - 1) * 7) + 3 ; // 1st of January + 7 days for each week

    return new Date(y, 0, d);
}

function setupSelectize() {
	var selector = document.getElementById("select-state")
	selector.onchange = function() { updateTable(this.value)}
}

function updateTable(abbreviation) {
	if (abbreviation == "All") {
		// show all rows
		$(".state-row").show()
	} else {
		// show specific row
		$(".state-row").hide()
		$(`#state-row-${abbreviation}`).show()
	}
	$('html, body').animate({scrollTop:$('#state-table').position().top}, 'slow');

}

// returns slope, intercept and r-square of the line
function leastSquares(xSeries, ySeries) {
	var reduceSumFunc = function(prev, cur) { return prev + cur; };
	
	var xBar = xSeries.reduce(reduceSumFunc) * 1.0 / xSeries.length;
	var yBar = ySeries.reduce(reduceSumFunc) * 1.0 / ySeries.length;

	var ssXX = xSeries.map(function(d) { return Math.pow(d - xBar, 2); })
	.reduce(reduceSumFunc);
	
	var ssYY = ySeries.map(function(d) { return Math.pow(d - yBar, 2); })
	.reduce(reduceSumFunc);

	var ssXY = xSeries.map(function(d, i) { return (d - xBar) * (ySeries[i] - yBar); })
	.reduce(reduceSumFunc);

	var slope = ssXY / ssXX;
	var intercept = yBar - (xBar * slope);
	var rSquare = Math.pow(ssXY, 2) / (ssXX * ssYY);
	
	return [slope, intercept, rSquare];
}

function getDaysDiff(date1, date2) {
	const diffTime = Math.abs(date2 - date1);
	const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
	return +diffDays
}

function roundTwoSigFigs(num) {
	return num.toPrecision(2)
}

function capitalizeFLetter(string) {
	return string[0].toUpperCase() +  string.slice(1); 
}


























propublica.views.socialSection = propublica.View.extend({
  cssClass: 'ss-social',
  tag: 'span',

  bindings: {
    click: 'socialRef',
  },

  socialRef: function(e) {
    e.preventDefault();
    var cur = $(e.currentTarget);
    if (cur.hasClass('ss-fb') || cur.hasClass("fb")) {
      this.fb(cur);
    }
    if (cur.hasClass('ss-tw') || cur.hasClass("tw")) {
      this.tw(cur);
    }
  },

  getTitle: function(cur) {
    return cur.attr('data-title');
  },

  getImg: function(cur) {
    return cur.attr('data-img');
  },

  getText: function(cur) {
    return cur.attr('data-txt');
  },

  getDesc: function(cur) {
    return cur.attr('data-desc');
  },

  getLink: function(cur) {
    return cur.attr('data-url');
  },

  getHashtag: function(cur) {
    return cur.attr('data-hashtag');
  },

  fb: function(cur) {
    window.dataLayer = window.dataLayer || [];
    var socialObj = {
      link: cur.attr('data-url'),
      name: cur.attr('data-title'),
      classes: cur.attr('class'),
      id: cur.attr('id'),
      network: 'facebook',
      action: 'share',
    };

    FB.ui(
      {
        method: 'feed',
        link: this.getLink(cur),
        picture: this.getImg(cur),
        name: this.getTitle(cur),
        caption: this.getText(cur),
        description: this.getDesc(cur),
      },
      function(response) {
        if (response['post_id'] !== undefined) {
          window.dataLayer.push({
            socialShare: socialObj,
            event: 'socialShare',
          });
        }
      }
    );
  },

  tw: function(cur) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'socialShare',
      socialShare: {
        link: cur.attr('data-url'),
        name: cur.attr('data-title'),
        classes: cur.attr('class'),
        id: cur.attr('id'),
        network: 'twitter',
        action: 'tweet-intent',
      },
    });

    var baseUrl = 'https://twitter.com/intent/tweet';
    baseUrl += '?text=' + encodeURIComponent(this.getText(cur));
    baseUrl += '&url=' + encodeURIComponent(this.getLink(cur));
    baseUrl += '&hashtags=' + encodeURIComponent(this.getHashtag(cur));
    window.open(baseUrl, '', 'toolbar=0, status=0, width=550, height=420');
  },
});

propublica.views.tweetTakeaways = propublica.View.extend({
  cssClass: 'anno-tweet',
  tag: 'span',

  bindings: {
    click: 'socialTweet',
  },

  socialTweet: function(e) {
    e.preventDefault();
    var cur = $(e.currentTarget);
    this.tw(cur);
  },

  getLink: function(cur) {
    return cur.attr('data-url');
  },

  getHashtag: function(cur) {
    return cur.attr('data-hashtag');
  },

  getText: function(cur) {
    return cur.attr('data-txt');
  },

  tw: function(cur) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'socialShare',
      socialShare: {
        link: cur.attr('data-url'),
        name: cur.attr('data-title'),
        classes: cur.attr('class'),
        id: cur.attr('id'),
        network: 'twitter',
        action: 'tweet-takeaways',
      },
    });

    var baseUrl = 'https://twitter.com/intent/tweet';
    baseUrl += '?text=' + encodeURIComponent(this.getText(cur));
    baseUrl += '&url=' + encodeURIComponent(this.getLink(cur));
    baseUrl += '&hashtags=' + encodeURIComponent(this.getHashtag(cur));
    window.open(baseUrl, '', 'toolbar=0, status=0, width=550, height=420');
  },
});

propublica.views.socialLI = propublica.views.socialSection.extend({
  cssClass: 'social-widget',
  tag: 'li',
});

propublica.views.socialMethods = propublica.views.socialSection.extend({
  cssClass: 'social-intent',
  tag: 'a',
});

